import { useEffect } from "react";

export default function SEO({ title, description, path = "" }) {
  useEffect(() => {
    const full = title ? `${title} | Dentro il Calice` : "Dentro il Calice — L'Influexpert del Vino";
    document.title = full;
    let meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `https://dentroilcalice.it${path}`);
  }, [title, description, path]);
  return null;
}
